import communityImage from "../assets/leadershipImg/imc2.jpg";
// import brandImage from "../assets/img/SUSTAINABLE-BRANDING.jpg";
// import prImage from "../assets/img/PUBLIC-RELATIONS.jpg";
// import advertisingImage from "../assets/img/ADVERTISING.jpg";
// import investorImage from "../assets/img/INVESTOR-RELATIONS.jpg";
// import advisoryImage from "../assets/img/COMMUNICATION-ADVISORY.jpg";


export const projects = [
  {
    id: "project-1", slug: "community-impact", title: "Community Impact",
    description: "A sample community engagement programme designed to build trust and support lasting local impact.",
    category: "Community Engagement", image: communityImage, featured: true,
    client: "Sample Client", industry: "Community Development", year: "2026",
    overview: "This sample case study demonstrates how a considered engagement programme can bring organisations and communities together around shared priorities.",
    challenge: "Create clear, two-way communication and meaningful participation across diverse community groups.",
    solution: "A tailored engagement approach combined stakeholder listening, accessible communications and coordinated outreach.",
    results: ["Clearer channels for community feedback", "A consistent framework for ongoing engagement"],
    services: ["Stakeholder mapping", "Community engagement", "Communications strategy"],
  },
  
];

export const getProjectBySlug = (slug) => projects.find((project) => project.slug === slug);
